// extracted by mini-css-extract-plugin
export default {"map":"OPcIWHv4Tq","click":"xp8vxZdAp5","container":"XOhdFfI492","widget":"Lv1jtniNFl"};